// Mirrors spidra-backend's config/acquisitionSources.ts -- no shared
// package between these repos, so this is a hand-kept copy. Keep both in
// sync if the option list ever changes.
export const ACQUISITION_SOURCES = [
  { value: "chatgpt", label: "ChatGPT" },
  { value: "claude", label: "Claude" },
  { value: "gemini", label: "Gemini" },
  { value: "copilot", label: "Copilot" },
  { value: "perplexity", label: "Perplexity" },
  { value: "google", label: "Google Search" },
  { value: "github", label: "GitHub" },
  { value: "reddit", label: "Reddit" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "twitter", label: "X / Twitter" },
  { value: "product_hunt", label: "Product Hunt" },
  { value: "youtube", label: "YouTube" },
  { value: "friend_colleague", label: "Friend / colleague" },
  { value: "other", label: "Other" },
] as const;

export type AcquisitionSourceValue = (typeof ACQUISITION_SOURCES)[number]["value"];
